import React from 'react';
import Button from '../ui/Button';
import './Header.css';

/**
 * Header Component
 *
 * @param {string} username - Current logged-in username
 * @param {function} onLogout - Logout handler
 * @param {function} onNavigate - Navigation handler
 * @param {boolean} isAuthenticated - Whether user is logged in
 * @param {boolean} isSubscribed - Whether user has active subscription
 */
function Header({ username, onLogout, onNavigate, isAuthenticated, isSubscribed, unclaimedBenefits, dateGenStatus }) {
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-title">
          <h1 className="header-logo">✨ Aesthetic Legends ✨</h1>
          <p className="header-subtitle">Generate AI Cards • Date • Explore • Win</p>
        </div>
        {isAuthenticated && (
          <div className="header-user-section">
            <span className="header-welcome">
              Welcome, <strong>{username}</strong>!
              {isSubscribed && (
                <span className="subscription-badge" title={unclaimedBenefits > 0 ? `${unclaimedBenefits} unclaimed weekly reward${unclaimedBenefits > 1 ? 's' : ''}!` : 'Premium Subscriber'}>
                  👑
                  {unclaimedBenefits > 0 && (
                    <span className="subscription-unclaimed-dot" />
                  )}
                </span>
              )}
            </span>
            {dateGenStatus && (
              <div className="header-date-gens">
                {dateGenStatus.unlimited ? (
                  <span className="date-gen-label" title="Unlimited date generations">
                    🎨 ∞
                  </span>
                ) : (
                  <>
                    <span className="date-gen-label" title="Weekly date generations remaining">
                      🎨 {dateGenStatus.weekly_remaining}/{dateGenStatus.weekly_cap}
                    </span>
                    {dateGenStatus.bonus_remaining > 0 && (
                      <span className="date-gen-bonus" title="Bonus date generations (permanent)">
                        +{dateGenStatus.bonus_remaining}
                      </span>
                    )}
                  </>
                )}
              </div>
            )}
            <Button
              variant="success"
              size="sm"
              onClick={() => onNavigate('shop')}
              leftIcon="🛒"
            >
              Shop
            </Button>
            <Button
              variant="info"
              size="sm"
              onClick={() => onNavigate('proposals')}
              leftIcon="💡"
            >
              Suggestions
            </Button>
            <Button
              variant="primary"
              size="sm"
              onClick={() => onNavigate('profile')}
              leftIcon="👤"
            >
              Profile
            </Button>
            <Button
              variant="danger"
              size="sm"
              onClick={onLogout}
              leftIcon="🚪"
            >
              Logout
            </Button>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
